import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import TagsService from "@/core/services/tags.service";
import ApiService from "@/core/services/api.service";
import CountryService from "@/core/services/country.service";
import ConfirmDialog from "@/view/pages/ConfirmDialog";

const COUNTRY = {
  name: "Austria",
  id: 140
};

const CITY = {
  name: "Vienna",
  id: 2737
};

const CITY_CATEGORY = "CITY";

export default {
  name: "districts",
  components: {
    ConfirmDialog
  },
  computed: {
    name() {
      return this.$i18n.t("menu.districts");
    },
    headers() {
      return [
        {
          text: "Id",
          align: "start",
          sortable: false,
          value: "id",
          width: "2%"
        },
        {
          text: this.$i18n.t("common.name"),
          value: "caption",
          sortable: true
        },
        {
          text: this.$i18n.t("common.active"),
          value: "active",
          sortable: false,
          align: "left"
        },
        {
          text: this.$i18n.t("common.order"),
          value: "ord",
          align: "false",
          sortable: true
        },
        {
          text: this.$i18n.t("common.shops"),
          value: "shopIds",
          align: "left",
          sortable: true
        },
        {
          text: this.$i18n.t("commonTable.country"),
          value: "country",
          sortable: false,
          align: "left"
        },
        {
          actions: "Actions",
          value: "actions",
          aling: "center",
          width: "2%",
          sortable: false
        }
      ];
    }
  },
  data() {
    return {
      country: COUNTRY,
      districtTags: [],
      originalDistrictTags: [],
      total: 100,
      tagsApiInitiated: false,
      loading: true,
      pagination: {
        page: 1,
        itemsPerPage: 10
      },
      showSidebar: false,
      editTagId: null,
      form: this.createForm(),
      valid: false,
      shops: [],
      shopsAreLoading: false,
      searchShops: "",
      selectedShops: null,
      openPanels: [0],
      searchTxt: "",
      countries: [],
      selectedCountry: null
      // newDistrictCountry: null
    };
  },
  watch: {
    pagination: {
      handler() {
        if (this.tagsApiInitiated) this.getTags();
      },
      deep: true
    }
  },
  async created() {
    this.loading = true;
  },
  async mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: this.name }]);
    await CountryService.init();
    this.$log.debug("await init tags service - start");
    await TagsService.init();
    this.$log.debug("await init tags service - end");
    this.tagsApiInitiated = true;

    this.getCountries();
    this.getShopList();
    this.getTags();
  },
  methods: {
    createForm() {
      return {
        caption: "",
        ord: null,
        shopIds: [],
        city: CITY.name
      };
    },
    setForm(tag) {
      this.selectedShops = this.findSelectedShops(tag.shopIds);
      return {
        caption: tag.caption,
        ord: tag.ord,
        shopIds: tag.shopIds,
        city: CITY.name
      };
    },
    findSelectedShops(shopIds) {
      if (!shopIds?.length) return [];
      return this.shops.filter(shop => {
        if (shopIds.includes(shop.id)) return shop;
      });
    },
    resetForm() {
      this.selectedShops = [];
      this.form = {
        caption: "",
        ord: null,
        shopIds: []
      };
    },
    getCountries() {
      this.loading = true;
      CountryService.getCountries()
        .then(res => {
          if (!res?.length) return;
          this.countries = res;
          const activeCountryId = CountryService.getActiveCountry();
          const defaultCountry = this.countries.find(item => item.id === activeCountryId);
          this.selectedCountry = defaultCountry;
          // this.newDistrictCountry = defaultCountry;
        })
        .catch(error => {
          this.$log.error("Error: ", error);
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },
    handleSortByLogic() {
      const sortMapping = {
        ord: "order",
        shopIds: "shops"
      };

      let sort;
      let sortBy = this.pagination.sortBy;
      let sortDesc = this.pagination.sortDesc;
      if (sortBy.length === 1 && sortDesc.length === 1) {
        sort = sortMapping[sortBy[0]] || sortBy[0];
        if (sortDesc[0] === true) sort += "_DESC";
      }

      return sort;
    },
    getRequestParams() {
      const params = {};
      const sort = this.handleSortByLogic();

      params["sort"] = sort?.toUpperCase();

      params["page"] = this.pagination.page - 1;
      params["size"] = this.pagination.itemsPerPage;
      params["showAll"] = true;
      params["category"] = CITY_CATEGORY;
      params["search"] = this.searchTxt;

      if (this.selectedCountry?.id) {
        params["countryId"] = this.selectedCountry.id;
      }

      return params;
    },
    async getTags() {
      this.loading = true;
      const reqParams = this.getRequestParams();
      const response = await TagsService.getTags(reqParams);
      this.districtTags = this.handleTagsTableData(response);
      this.originalDistrictTags = this.handleTagsTableData(response);
      this.total = response.data.totalElements;
      this.$store.dispatch(SET_BREADCRUMB, [{ title: `${this.name}: ` + this.total }]);
      this.loading = false;
    },
    handleTagsTableData(response) {
      if (!response?.data) return [];
      return (
        response.data.content.map(item => ({
          ...item,
          country: "Austria",
          totalShops: item.shopIds?.length || 0
        })) || []
      );
    },
    getShopList() {
      ApiService.query("api/shops/dropdown-list")
        .then(res => {
          this.shops = res.data;
        })
        .catch(error => {
          this.$log.error("Error: ", error);
        })
        .finally(() => (this.shopsAreLoading = false));
    },
    selectAllShops(event) {
      this.shopsToAdd = event ? this.shops : [];
    },
    onSearch() {
      this.loading = true;
      this.getTags();
    },
    onEditTag(tag) {
      this.showSidebar = true;
      this.editTagId = tag.id;
      this.form = this.setForm(tag);
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    onToggleTagActive(tag) {
      this.loading = true;
      TagsService.setTagActiveState(tag.id)
        .then(res => {
          console.log("setTagActiveState", res);
        })
        .finally(() => (this.loading = false));
    },
    async onDeleteTag(tag) {
      const confirm = await this.$refs.confirm.open(
        this.$i18n.t("common.confirm"),
        this.$i18n.t("common.areYouSure") + "?"
      );
      if (!confirm) return;
      TagsService.deleteTag(tag.id).then(() => {
        this.successToastrMessage();
        this.getTags();
      });
    },
    onChangeCountry() {
      this.getTags();
    },
    async save() {
      if (!this.$refs.form.validate()) return;

      console.log(this.form);

      const postModel = {
        ...this.form,
        category: CITY_CATEGORY,
        cityId: CITY.id,
        shopIds: this.selectedShops.map(item => item.id)
      };

      try {
        const request = this.editTagId
          ? TagsService.updateTag(postModel, this.editTagId)
          : TagsService.createTag(postModel);

        this.loading = true;

        await request.finally(() => (this.loading = false));

        this.getTags();
        this.closeSidebar();
        this.successToastrMessage();
      } catch (error) {
        this.$bvToast.toast("Error: " + error, {
          title: this.$i18n.t("menu.messages"),
          solid: true,
          variant: "error",
          autoHideDelay: 2000
        });
      }
    },
    openSidebar() {
      this.showSidebar = true;
    },
    closeSidebar() {
      this.showSidebar = false;
      this.editTagId = null;
      this.resetForm();
    },
    successToastrMessage() {
      this.$bvToast.toast(this.$i18n.t("common.savedSuccessfully"), {
        title: this.$i18n.t("menu.tags"),
        solid: true,
        variant: "success",
        autoHideDelay: 1000
      });
    }
  }
};
